module.exports = __webpack_public_path__ + "static/img/loadImg.41dcd80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loadImg.jpg
// module id = B7gR
// module chunks = 1